import { createSlice } from "@reduxjs/toolkit";

export const configSlice = createSlice({
  name: "config",
  initialState: {
    // appKey: '1599887751',
    // // ctxPath: "http://localhost:39100",
    // ctxPath: "http://192.168.42.155:39100",
    // imgPath: "http://192.168.42.155:39100/uploads",
    // appKey: '1599887751',
    // ctxPath: "http://47.113.230.59:39100",
    // imgPath: "http://47.113.230.59:39100/uploads",
    // keyboardEditer: "https://h5.clgm666.site/keyboardEditer",
    // xboxEditer: "https://h5.clgm666.site/xboxEditer",
    appKey: '0134938397',
    ctxPath: "https://server.ruyungame.com",
    imgPath: "https://server.ruyungame.com/uploads",
    keyboardEditer: "https://play.ruyungame.com/keyboardEditer",
    xboxEditer: "https://play.ruyungame.com/xboxEditer",
    done: false,
    clientType: 'Admin',
    version: '1.0.0',
    maintain: false, //是否正在维护
  },
  reducers: {
    initConfig: (state) => {
      state.done = true;
    },
    setMaintain: (state, params) => {
      state.maintain = params.payload.data;
    },
    setCtxPath: (state, params) => {
      state.ctxPath = params.payload;
    },
  },
});

export const { initConfig, setMaintain, setCtxPath } = configSlice.actions;

export default configSlice.reducer;
